const EmptyRouterView = () => /* webpackChunkName: "EmptyRouterView" */ import("./../views/medic_contra_hcm/EmptyRouterView.vue");
const medicHosp = () => /* webpackChunkName: "Home" */ import("./../views/medic_contra_hcm/Home.vue");
const ControllerMedic = () => /* webpackChunkName: "ControllerMedicHcm" */ import("./../views/medic_contra_hcm/telemedical/ControllerMedicHcm.vue");
const InterconsultHome = () => /* webpackChunkName: "InterconsultHome" */ import("./../views/medic_contra_hcm/Interconsult/InterconsultHome.vue");
const ApsRequestHome = () => /* webpackChunkName: "ApsRequestHome" */ import("./../views/medic_contra_hcm/Interconsult/ApsRequestHome.vue");
const Document = () => /* webpackChunkName: "Document" */ import("@/views/general/Document.vue");

export const routes = [
  {
    path: "/mediContralorHcm",
    component: EmptyRouterView,
    children: [
      {
        path: "",
        name: "mediContraHcmhome",
        component: medicHosp,
      },
      {
        path: "interconsulta-medico-contralor",
        name: "controllerMedicHcm",
        component: ControllerMedic,
      },
      {
        path: "interconsulta-home-medico-contralor",
        name: "interconsultMedicContra",
        component: InterconsultHome,
      },
      {
        path: "interconsulta-observadas-medico-contralor",
        name: "apsRequestMedicContra",
        component: ApsRequestHome,
      },
      {
        path: "documentacion",
        name: "comptrollerMedicHcmDocumentation",
        component: Document,
      },
    ],
  },
];
